import { Dayjs } from "dayjs";

export interface ControlException {
  startDate: string;
  endDate: string;
}

export interface LoadingInformation {
  _id?: string;
  year: number | null;
  companyId: string | null;
  chemicalId: string;
  loadingById: string;
  emissionControlId: string;
  chemicalName: string;
  loadingBy: string;
  emissionControl: string;
  area: string;
  efficiency: number;
  controlExceptionDate: ControlException[];
  arrControlExceptionDate: string[];
  isWarning?: boolean;
  isFlowActive?: boolean;
}

export interface OptionFilter {
  key: string;
  filter: [];
}

export interface Filter {
  text: string;
  value: string;
}

export interface Dropdown {
  key?: string;
  label: string;
  value: string | number;
}

export interface DateRange {
  start: Dayjs;
  end: Dayjs;
}

export const initialInform: LoadingInformation = {
  year: null,
  companyId: null,
  chemicalId: "",
  area: "",
  loadingById: "",
  emissionControlId: "",
  chemicalName: "",
  loadingBy: "",
  emissionControl: "",
  efficiency: 0,
  controlExceptionDate: [],
  arrControlExceptionDate: [],
};

export interface MonthlyVolume {
  value: number | null;
  reportStatus: string;
}

export interface ChemicalVolume {
  _id?: string;
  year: number | null;
  companyId: string;
  area: string;
  unit: string;
  manualChemicalVolume: ManualChemicalVolume;
}

export interface ManualChemicalVolume {
  jan: MonthlyVolume;
  feb: MonthlyVolume;
  mar: MonthlyVolume;
  apr: MonthlyVolume;
  may: MonthlyVolume;
  jun: MonthlyVolume;
  jul: MonthlyVolume;
  aug: MonthlyVolume;
  sep: MonthlyVolume;
  oct: MonthlyVolume;
  nov: MonthlyVolume;
  dec: MonthlyVolume;
}

export interface StaticColumnsType {
  label: string;
  key: string | string[];
}

export interface ReportChemicalVolume {
  _id?: string;
  companyId: string;
  year: number | "";
  chemicalName: string;
  area: string;
  loadingBy: string;
  unit: string;
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  total: number;
}

export interface Month {
  title: string;
  dataIndex: keyof ReportChemicalVolume;
}

export const MonthsKeys = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

export interface UnitTerminalVoc {
  [key: string]: {
    data: ReportVocEmission[];
    summary: SummaryVocEmission[];
  };
}

export interface ReportVocEmission {
  _id: string;
  chemicalName: string;
  area: string;
  loadingBy: string;
  emission: string;
  unit: string;
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  total: number;
}

export interface MonthVocEmiss {
  title: string;
  dataIndex: keyof ReportVocEmission;
}

export interface Option {
  _id?: string;
  label: string;
  value: string;
}

export interface WidthCol {
  jan: string;
  feb: string;
  mar: string;
  apr: string;
  may: string;
  jun: string;
  jul: string;
  aug: string;
  sep: string;
  oct: string;
  nov: string;
  dec: string;
}

export interface SummaryVocEmission {
  key: string;
  label: string;
  emission: string;
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  unit: string;
  total: number;
}

export interface multipleApprover {
  approverName: String;
  approverUserId: String;
  email: String;
}

export interface StepsApprove {
  stepNo: number;
  stepName: string;
  approverName: string;
  approverUserId: string;
  email: string;
  datetime: string;
  comment: string;
  status: string;
  role: string;
  isDetectUpdateStep: boolean;
  isMultipleApprover: boolean;
  multipleApprover: multipleApprover[];
}

export interface TerminalMarketApprove {
  status: string;
  month: string;
  year: number;
  companyId: string;
  approveNo: number;
  steps: StepsApprove[];
  currentStep: number;
}

export interface ApproveBody {
  userId: string;
  approveId: string;
  comment: string;
  stepApprove: number;
  status: string;
  name: string;
  email: string;
}

export enum StatusStepEnum {
  REQUEST = "request_approval",
  APPROVED = "approved",
  REJECT = "reject",
  WAITING_FOR_APPROVE = "waiting_for_approval",
}
